var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _vm.env === "dev" || _vm.env === "qa"
          ? _c("div", { staticClass: "env" }, [
              _vm._v("Miljö: " + _vm._s(_vm.env))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "nav",
          { staticClass: "navbar fixed-top bg-white" },
          [
            _c(
              "a",
              {
                class: _vm.disableHref ? "disabled-href" : "",
                attrs: { href: _vm.setHref() }
              },
              [
                _c("img", {
                  staticClass: "img-fluid img-logo",
                  attrs: {
                    src: require("@/assets/img/logo.svg?data"),
                    alt: "FHabian.nu logotyp"
                  }
                })
              ]
            ),
            _vm._v(" "),
            !_vm.region
              ? _c("div", [
                  _c("div", { staticClass: "row row-margin mr-2" }, [
                    _c("div", { staticClass: "col-lg-8" }, [
                      !_vm.isDashboardOrFamilytree
                        ? _c("img", {
                            staticClass: "img-margin header sthlmlogo",
                            attrs: {
                              src: require("../assets/img/regioner/SE2321000016/header.svg"),
                              alt: "Header för Region Stockholm"
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-4" }, [
                      !_vm.isDashboardOrFamilytree
                        ? _c("img", {
                            staticClass: "img-margin header skanelogo",
                            attrs: {
                              src: require("../assets/img/regioner/SE162321000255/header.svg"),
                              alt: "Header för Region Skåne"
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isRoot
              ? _c(
                  "router-link",
                  {
                    staticClass: "top-right-register",
                    attrs: { to: "/register" }
                  },
                  [_vm._v("Registrering")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isRoot
              ? _c(
                  "router-link",
                  { staticClass: "top-right-login", attrs: { to: "/login" } },
                  [_vm._v("Logga in")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("img", {
              staticClass: "navbar-toggler img-fluid",
              attrs: {
                src: require("@/assets/img/hamburger.svg?data"),
                alt: "Ikon för hamburgarmeny",
                "data-toggle": "collapse",
                "data-target": "#collapsibleNavbar"
              }
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "nav-horizontal" }, [
              _c("li", { staticClass: "nav-item nav-horizontal-li" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    class: _vm.disableHref ? "disabled-href" : "",
                    attrs: { href: _vm.setHref() }
                  },
                  [_vm._v("Till start")]
                )
              ]),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item nav-horizontal-li" },
                [
                  _c("div", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          name: "faq",
                          params: { page: _vm.pages.whatisfh }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.data.faq.topHeader1) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item nav-horizontal-li" },
                [
                  _c("div", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          name: "faq",
                          params: { page: _vm.pages.aboutapp }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.data.faq.topHeader3) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item nav-horizontal-li" },
                [
                  _c("div", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: {
                          name: "faq",
                          params: { page: _vm.pages.helpresearch }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.data.faq.topHeader4) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item nav-horizontal-li" },
                [
                  _c("div", { staticClass: "divider" }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        to: { name: "faq", params: { page: _vm.pages.contact } }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.data.faq.topHeader5) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse navbar-collapse",
                attrs: { id: "collapsibleNavbar" }
              },
              [
                _c("ul", { staticClass: "navbar-nav ml-auto" }, [
                  _c("li", { staticClass: "nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-link text-primary-fh",
                        class: _vm.disableHref ? "disabled-href" : "",
                        attrs: { href: _vm.setHref() }
                      },
                      [_vm._v("Till start")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-primary-fh",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#collapsibleNavbar",
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.whatisfh }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.faq.topHeader1) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-primary-fh",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#collapsibleNavbar",
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.aboutapp }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.faq.topHeader3) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-primary-fh",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#collapsibleNavbar",
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.helpresearch }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.faq.topHeader4) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "nav-link text-primary-fh",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#collapsibleNavbar",
                            to: {
                              name: "faq",
                              params: { page: _vm.pages.contact }
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.data.faq.topHeader5) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.notRootOrLogin() && _vm.doesTokenExist()
                    ? _c("div", { staticClass: "dropdown-divider" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.notRootOrLogin() && _vm.doesTokenExist()
                    ? _c("li", { staticClass: "nav-item" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "nav-link text-primary-fh cursor-pointer",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": "#collapsibleNavbar"
                            },
                            on: {
                              click: function($event) {
                                return _vm.logOut()
                              }
                            }
                          },
                          [_c("strong", [_vm._v("Logga ut")])]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ab79656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab79656","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = null
// module chunks = 